<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขเกี่ยวกับเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <div class="mb-3">
                    <h2>เกี่ยวกับเรา</h2>
                </div>
                <div class="d-flex align-center mb-3">
                    <div>
                        อัพเดทล่าสุด : {{ detail_content.updated_at }} น. โดย {{ detail_content.user }}
                    </div>
                </div>
                <div>
                    <quillEditor ref="myQuillEditor" v-model="content" :options="$store.state.editorOption" />
                </div>
                <div class="d-flex justify-center align-center mt-3">
                    <v-btn height="65" width="20%" color="#28ab28" class="white--text" @click="editAbout()">
                        บันทึกการแก้ไข
                    </v-btn>
                </div>
            </div>
        </v-card>

    </div>
</div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import Quill from 'quill'
import {
    ImageDrop
} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

import {
    quillEditor
} from 'vue-quill-editor'
import contentabout from '@/api/content/contentsetting/contentabout.js'
export default {
    components: {
        quillEditor
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show_edit: false,
            detail_content: null,
            content: '',
        }
    },
    computed: {
        editor() {
            return this.$refs.myQuillEditor.quill
        }
    },
    methods: {
        async contentAboutList() {
            this.loading_page = true
            this.detail_content = null
            this.content = ''
            contentabout.aboutList().then((response) => {
                if (response.data.successful === true) {
                    this.detail_content = response.data.about
                    this.content = response.data.about.content
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async editAbout() {
            const data = {
                content: this.content,
            }
            contentabout.editAbout(this.detail_content.id, data).then((response) => {
                if (response.data.successful === true) {
                    this.contentAboutList()
                    this.alert_show_edit = true
                    setTimeout(() => this.alert_show_edit = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

        }
    },
    mounted() {
        this.contentAboutList()
    }
}
</script>
